<template>
  <div @click.stop class="table-header-cell-dropdown__options-datepicker">
    <div class="table-header-cell-dropdown__options-datepicker-inputs">
      <div class="table-header-cell-dropdown__options-datepicker-input-wrap">
        <input type="text"
               :value="value && value[0]"
               readonly
               class="table-header-cell-dropdown__options-datepicker-input">
        <button @click.prevent="onClear"
                class="table-header-cell-dropdown__options-datepicker-input-clear">
          <BaseSvg name="ico-close"/>
        </button>
      </div>
      <span class="table-header-cell-dropdown__options-datepicker-inputs-separator"> - </span>
      <div class="table-header-cell-dropdown__options-datepicker-input-wrap">
        <input type="text"
               :value="value && value[1]"
               readonly
               class="table-header-cell-dropdown__options-datepicker-input">
        <button @click.prevent="onClear"
                class="table-header-cell-dropdown__options-datepicker-input-clear">
          <BaseSvg name="ico-close"/>
        </button>
      </div>
    </div>

    <DatePicker v-bind="$attrs"
                inline
                range
                :value="value"
                format="DD.MM.YYYY"
                value-type="format"
                :lang="lang"
                v-on="$listeners">
    </DatePicker>
  </div>
</template>

<script>
  import datePickerMixin from '@/mixins/datePickerMixin'

  export default {
    name: 'APResumesBaseResumePageHeadRowStatusDateRange',
    mixins: [datePickerMixin],
    props: {
      value: Array
    },
    data() {
      return {}
    },
    methods: {
      onClear() {
        this.$emit('clear')
      }
    }
  }
</script>

<style lang="less">

</style>
